import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../utils/lib/utils';

export function Timeline({ items, className }) {
  return (
    <div className={cn("relative", className)}>
      {items.map((item, index) => (
        <div key={index} className="mb-8 flex items-start last:mb-0">
          <div className="flex flex-col items-center mr-4">
            <div className="w-3 h-3 bg-indigo-600 rounded-full" />
            {index !== items.length - 1 && (
              <div className="w-0.5 h-full bg-neutral-200 dark:bg-neutral-700" />
            )}
          </div>
          <div className="flex-1">
            <div className="flex items-center mb-1">
              <span className="text-sm font-medium text-neutral-900 dark:text-white">
                {item.status}
              </span>
              <span className="ml-2 text-sm text-neutral-500 dark:text-neutral-400">
                {new Date(item.date).toLocaleDateString()}
              </span>
            </div>
            <p className="text-sm text-neutral-600 dark:text-neutral-300">
              {item.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

Timeline.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
};

Timeline.defaultProps = {
  className: '',
}; 